<template>
  <div class="text-input clearfix">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label
        :for="options.name"
        :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <div :class="{ 'input-group': maxLength }">
          <input class="form-control" type="text"
            :id="options.name"
            :value="value"
            :class="isDirty ? isValid ? 'is-valid' : 'is-invalid' : ''"
            @input="validate($event.target.value)"
            :name="options.name"/>
          <div v-if="maxLength" class="input-group-append">
            <span class="input-group-text">
              {{ maxLength - (value ? value.length : 0) >= 0 ? maxLength - (value ? value.length : 0) : 0 }} chars
            </span>
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span v-if="!maxLength" :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'TextInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          value: ''
        }
      }
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      if (this.maxLength && this.value && this.value.length > this.maxLength) {
        return 'Max characters cannot exceed ' + this.maxLength
      } else {
        return this.options.label + ' is required'
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      isLength: true,
      isRegex: true,
      minLength: 1,
      maxLength: false
    }
  },
  mounted () {
    if (this.options.maxLength) { this.maxLength = this.options.maxLength }
    this.validate(this.value)
    this.isDirty = false
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (val) {
        this.isDirty = true
        this.isLength = this.isValid = val.length >= this.minLength
        if (this.isLength && this.maxLength) {
          this.isValid = val.length <= this.maxLength
        }
      } else if (this.options.required) {
        this.isValid = false
        this.isDirty = true
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/TextInput.vue